import React, { useEffect, useState } from "react";
import SearchComponent from "../../components/search";
import Table from '../../components/datatable/datatable';
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Dropdown from "../../components/dropdown";
import { fetchAllInvoices, adminDeleteInvoice, adminUpdateInvoiceStatus, fetchDashboardData } from "../../core/axios/endpoints";
import Papa from "papaparse";
import Swal from "sweetalert2";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoiceDocument from "../../components/invoice-pdf";
import FinancialCharts from "../../components/financial-charts";

const AdminFinancieelPage = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [SelectedRows, setSeletedRows] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [statistics, setStatistics] = useState({
        countBetaald: 0,
        countNietBetaald: 0,
        totalAmountBetaald: 0,
    });
    // Omzet-projectie (betaald + verwacht) uit het dashboard-endpoint, zodat
    // deze cijfers exact gelijk zijn aan de home-pagina en de BTW-pagina.
    const [revenue, setRevenue] = useState({
        totalRevenue: 0,
        totalRevenueProjected: 0,
        btwRevenueExpected: 0,
    });

    const navigate = useNavigate();

    useEffect(() => {
        let active = true;
        fetchDashboardData()
            .then((res) => {
                if (!active || !res) return;
                setRevenue({
                    totalRevenue: res.totalRevenue ?? 0,
                    totalRevenueProjected: res.totalRevenueProjected ?? res.totalRevenue ?? 0,
                    btwRevenueExpected: res.btwRevenueExpected ?? 0,
                });
            })
            .catch(() => {});
        return () => {
            active = false;
        };
    }, []);

    const closeDropdown = (record) => {
        document.getElementById(`dropdown-klanten-action-${record?.id}`)?.removeAttribute("open");
    };

    const columns = [
        {
            title: "Factuur-Nummer",
            dataIndex: "InvoiceId",
            sorter: (a, b) => a.InvoiceId.localeCompare(b.InvoiceId),
        },
        {
            title: "Naam",
            dataIndex: ["user", "naam"],
            sorter: (a, b) => a.user.naam.localeCompare(b.user.naam),
        },
        {
            title: "Email",
            dataIndex: ["user", "email"],
            sorter: (a, b) => a.user.email.localeCompare(b.user.email),
        },
        {
            title: "Bedrijf",
            dataIndex: ["user", "bedrijfsnaam"],
            sorter: (a, b) => a.user.bedrijfsnaam.localeCompare(b.user.bedrijfsnaam),
        },
      
        {
            title: "Regeling",
            dataIndex: ["application", "regling"],
            sorter: (a, b) => a.application.regling.localeCompare(b.application.regling),
        },
        {
            title: "Bedrag",
            dataIndex: ["application", "totaal"],
            render: (a) => `€ ${formatNumber(a || '0')}`,
            sorter: (a, b) => a.application.totaal - b.application.totaal,
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text) => (
                <span className={`inline-flex items-center rounded px-1.5 py-px text-[11px] font-bold uppercase tracking-wide ${text === 'Betaald' ? 'bg-[#DCFFF1] text-[#1F845A]' : 'bg-[#FFF7D6] text-[#7F5F01]'}`}>
                    {text}
                </span>
            ),
            sorter: (a, b) => a.status.localeCompare(b.status),
        },
        {
            title: "Action",
            render: (record) => (
                <>
                    <Dropdown className="dropdown-action dropdown dropdown-end" id={"dropdown-klanten-action-" + record?.id}>
                        <summary className="inline-flex h-8 w-8 cursor-pointer list-none items-center justify-center rounded text-ink-subtlest hover:bg-[#091E420F] focus:outline-none">
                            <FeatherIcon icon="more-vertical" size={16} />
                        </summary>
                        <ul className="dropdown-content z-[1] flex w-fit min-w-[10rem] flex-col rounded bg-white p-1 shadow-overlay">
                          {record.status !== 'Betaald' &&  <Link onClick={() => { closeDropdown(record); handleMarkPaid(record) }} className="link-ancher cursor-pointer whitespace-nowrap rounded px-2 py-1.5 text-sm text-ink hover:bg-[#091E420F]">
                                Markeer Betaald
                            </Link>}
                            <PDFDownloadLink
                                document={<InvoiceDocument invoiceData={record} />}
                                fileName={record?.InvoiceId + ".pdf"}
                                onClick={() => { closeDropdown(record) }}
                                className="animate-none bg-none link-ancher cursor-pointer whitespace-nowrap rounded px-2 py-1.5 text-sm text-ink hover:bg-[#091E420F]"
                            >
                                {({ blob, url, loading, error }) =>
                                    loading ? 'Loading document...' : 'Download PDF'
                                }
                            </PDFDownloadLink>
                        </ul>
                    </Dropdown>
                </>
            ),
        },
    ];

    const fetchData = async ({ page, pageSize, resetPageSize }) => {
        try {
            setLoading(true);
            const response = await fetchAllInvoices(page, pageSize, searchText);
            setStatistics({
                countBetaald: response?.countBetaald,
                countNietBetaald: response?.countNietBetaald,
                totalAmountBetaald: response?.totalAmountBetaald,
            })
            const result = {
                data: response.docs.map((invoice, index) => ({ ...invoice, key: index })),
                totalDataCount: response.totalDocs,
                resetPageSize,
            };
            setData(result);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData({ page: 1, pageSize: 10, resetPageSize: false });
    }, [searchText]);

    const handleSearch = (query) => {
        setSearchText(query);
    };

    const handleDelete = async () => {
        Swal.fire({
            title: 'Weet je het zeker?',
            text: "Dit kan niet ongedaan worden gemaakt!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ja, verwijder het!',
            cancelButtonText: 'Annuleren'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await adminDeleteInvoice(SelectedRows);
                    fetchData({ page: 1, pageSize: 10, resetPageSize: false });
                    setSeletedRows([]);
                    Swal.fire(
                        'Verwijderd!',
                        'De geselecteerde facturen zijn verwijderd.',
                        'success'
                    );
                } catch (error) {
                    console.error("Error deleting invoices:", error);
                    Swal.fire(
                        'Mislukt!',
                        'Er is een fout opgetreden bij het verwijderen van de facturen.',
                        'error'
                    );
                }
            }
        });
    };

    const handleMarkPaid = async (record) => {
        Swal.fire({
            title: 'Weet je het zeker?',
            text: "Wil je deze factuur markeren als betaald?",
            icon: 'warning',
            input: 'checkbox',
            inputValue: 1,
            inputPlaceholder: 'Klant een bevestigingsmail sturen',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja, markeer als betaald',
            cancelButtonText: 'Annuleren'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const notifyCustomer = result.value === 1;
                try {
                    await adminUpdateInvoiceStatus(record._id, { status: 'Betaald', notifyCustomer });
                    fetchData({ page: 1, pageSize: 10, resetPageSize: false });
                    Swal.fire(
                        'Gemarkeerd!',
                        notifyCustomer
                            ? 'De factuur staat op betaald en de klant heeft een bevestiging gekregen.'
                            : 'De factuur staat op betaald. Er is geen mail naar de klant gestuurd.',
                        'success'
                    );
                } catch (error) {
                    console.error("Error updating invoice status:", error);
                    Swal.fire(
                        'Mislukt!',
                        'Er is een fout opgetreden bij het markeren van de factuur als betaald.',
                        'error'
                    );
                }
            }
        });
    };

    const handleMarkPaidBulk = async () => {
        if (!SelectedRows?.length) return;

        const confirm = await Swal.fire({
            title: `${SelectedRows.length} factu${SelectedRows.length === 1 ? 'ur' : 'ren'} markeren als betaald?`,
            text: 'Facturen die al Betaald zijn worden door de server overgeslagen.',
            icon: 'warning',
            input: 'checkbox',
            inputValue: 1,
            inputPlaceholder: 'Klanten een bevestigingsmail sturen',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Ja, markeer ${SelectedRows.length} betaald`,
            cancelButtonText: 'Annuleren',
        });
        if (!confirm.isConfirmed) return;
        const notifyCustomer = confirm.value === 1;

        const results = await Promise.allSettled(
            SelectedRows.map((id) =>
                adminUpdateInvoiceStatus(id, { status: 'Betaald', notifyCustomer }),
            ),
        );
        const succeeded = results.filter((r) => r.status === 'fulfilled').length;
        const failed = results.length - succeeded;

        setSeletedRows([]);
        fetchData({ page: 1, pageSize: 10, resetPageSize: false });

        if (failed === 0) {
            Swal.fire(
                'Gemarkeerd!',
                `${succeeded} factu${succeeded === 1 ? 'ur is' : 'ren zijn'} verwerkt${notifyCustomer ? '' : ', zonder mail naar de klanten'}.`,
                'success',
            );
        } else {
            Swal.fire(
                'Deels gelukt',
                `${succeeded} verwerkt, ${failed} mislukt. Probeer de mislukte opnieuw.`,
                'warning',
            );
        }
    };


    const handleExport = () => {
        const csvData = data.data.map(row => ({
            ID: row._id || 'N/A',
            Naam: row?.user?.naam || 'N/A',
            Email: row?.user?.email || 'N/A',
            Bedrijfsnaam: row?.user?.bedrijfsnaam || 'N/A',
            FactuurNummer: row?._id || 'N/A',
            Regeling: row?.application?.regling || 'N/A',
            Bedrag: row?.application?.totaal || 'N/A',
            Status: row?.status || 'N/A',
            BetaaldDatum: row?.betaaldDateTime ? new Date(row?.betaaldDateTime).toLocaleDateString() : 'N/A'
        }));
        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "facturen.csv");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const RowChanges = (rows) => {
        setSeletedRows(rows);
        
    };

    const formatNumber = (number) => {
        return number.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

    return (
        <>
            <div className="page-wrapper">
                <div className="content admin-pages">
                    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
                        <div>
                            <nav className="mb-1 text-xs text-ink-subtlest" aria-label="Breadcrumb">
                                <Link to="/panel/admin/dashboard" className="hover:underline">Dashboard</Link>
                                <span className="mx-1">/</span>
                                <span>Administratie</span>
                                <span className="mx-1">/</span>
                                <span>Financieel</span>
                            </nav>
                            <h1 className="text-2xl font-medium text-ink">Financieel</h1>
                        </div>
                        <div className="flex flex-wrap items-center gap-2">
                            <Link
                                to="/panel/admin/btw-batterij-overzicht?status=paid"
                                className="inline-flex h-8 items-center gap-1.5 rounded bg-[#091E420F] px-3 text-sm font-medium text-ink hover:bg-[#091E4224]"
                            >
                                BTW-aanvragen
                                <FeatherIcon icon="arrow-right" size={16} />
                            </Link>
                            <Link
                                to="/panel/admin/partner-facturen"
                                className="inline-flex h-8 items-center gap-1.5 rounded bg-[#091E420F] px-3 text-sm font-medium text-ink hover:bg-[#091E4224]"
                            >
                                Partner-facturen
                                <FeatherIcon icon="arrow-right" size={16} />
                            </Link>
                        </div>
                    </div>

                    <div className="rounded bg-white p-4 shadow-card">
                        <FinancialCharts />
                    </div>

                    <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
                        <div className="rounded bg-white p-4 shadow-card">
                            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Betaald</p>
                            <p className="mt-2 text-2xl font-medium tabular-nums text-ink">{statistics.countBetaald}</p>
                            <p className="mt-1 text-xs text-ink-subtlest">Subsidie-facturen</p>
                        </div>
                        <div className="rounded bg-white p-4 shadow-card">
                            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Niet Betaald</p>
                            <p className="mt-2 text-2xl font-medium tabular-nums text-ink">{statistics.countNietBetaald}</p>
                            <p className="mt-1 text-xs text-ink-subtlest">Subsidie-facturen</p>
                        </div>
                        <div className="rounded bg-white p-4 shadow-card">
                            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Totaal Omzet</p>
                            <p className="mt-2 text-2xl font-medium tabular-nums text-ink">€ {formatNumber(statistics.totalAmountBetaald || '0')}</p>
                            <p className="mt-1 text-xs text-ink-subtlest">Betaalde subsidie-facturen</p>
                        </div>
                    </div>

                    {/* Omzet-projectie: betaald + verwacht (BTW nog niet betaald),
                        identiek aan de home- en BTW-pagina. */}
                    <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
                        <div className="rounded bg-white p-4 shadow-card">
                            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Omzet betaald</p>
                            <p className="mt-2 text-2xl font-medium tabular-nums text-brand">
                                € {formatNumber(revenue.totalRevenue || 0)}
                            </p>
                            <p className="mt-1 text-xs text-ink-subtlest">Subsidie + BTW, alle stromen</p>
                        </div>
                        <div className="rounded bg-white p-4 shadow-card">
                            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Verwacht (nog niet betaald)</p>
                            <p className="mt-2 text-2xl font-medium tabular-nums text-[#7F5F01]">
                                € {formatNumber(revenue.btwRevenueExpected || 0)}
                            </p>
                            <p className="mt-1 text-xs text-ink-subtlest">BTW-aanvragen in behandeling</p>
                        </div>
                        <div className="rounded bg-white p-4 shadow-card">
                            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Totaal projectie</p>
                            <p className="mt-2 text-2xl font-medium tabular-nums text-ink">
                                € {formatNumber(revenue.totalRevenueProjected || 0)}
                            </p>
                            <p className="mt-1 text-xs text-ink-subtlest">Betaald + verwacht</p>
                        </div>
                    </div>

                    <div className="mt-8 mb-4 flex flex-wrap items-end justify-between gap-3">
                        <div>
                            <h2 className="text-base font-semibold text-ink">Subsidie-facturen</h2>
                            <p className="text-xs text-ink-subtlest">EIA · EIA Zon · ISDE - facturen aan klanten</p>
                        </div>
                    </div>
                    <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
                        <div className="w-full max-w-md">
                            <SearchComponent onSearch={handleSearch} type={'invoices'} />
                        </div>
                        <div className="flex flex-wrap items-center gap-2">
                            <button
                                type="button"
                                disabled={!SelectedRows?.length}
                                className="inline-flex h-8 items-center gap-1.5 rounded bg-[#091E420F] px-3 text-sm font-medium text-ink hover:bg-[#091E4224] disabled:cursor-not-allowed disabled:opacity-50"
                                onClick={handleExport}
                            >
                                <FeatherIcon icon="download" size={16} />
                                Exporteer
                            </button>
                            <button
                                type="button"
                                disabled={!SelectedRows?.length}
                                className="inline-flex h-8 items-center gap-1.5 rounded bg-brand px-3 text-sm font-medium text-white hover:bg-brand-hover disabled:cursor-not-allowed disabled:opacity-50"
                                onClick={handleMarkPaidBulk}
                            >
                                <FeatherIcon icon="check-circle" size={16} />
                                Markeer als betaald {SelectedRows?.length ? `(${SelectedRows.length})` : ''}
                            </button>
                            <button
                                type="button"
                                disabled={!SelectedRows?.length}
                                className="inline-flex h-8 items-center gap-1.5 rounded bg-[#C9372C] px-3 text-sm font-medium text-white hover:bg-[#AE2A19] disabled:cursor-not-allowed disabled:opacity-50"
                                onClick={handleDelete}
                            >
                                <FeatherIcon icon="trash-2" size={16} />
                                Verwijder
                            </button>
                        </div>
                    </div>
                    <div className="table-responsive rounded bg-white shadow-card">
                        <Table
                            columns={columns}
                            response={data}
                            fetchData={fetchData}
                            SelectedRows={RowChanges}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminFinancieelPage;
